<div class="qt-base-selection qt-error-section">
  <h3 class="qt-error-section__title" i18n>Something went wrong</h3>
  <p class="qt-error-section__text" i18n>
    Sorry, something went wrong during the process to send your quote.<br />Please try to send it again or contact us if the error persists.
  </p>
  <lx-button class="qt-error-section__button" buttonStyle="primary" [btnRounded]="true" i18n-text text="Try again" (click)="goBack()"></lx-button>
</div>
